import request from '@/utils/request'
import qs from 'qs'

const proxyUrl = process.env.Communityapi;
const Jingjiribao = process.env.Jingjiribao;


// 社区关注列表
export const topicFollow = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    url: proxyUrl + '/circle/topicFollow/page',
    data: qs.stringify(data),

  })
};



//圈子详情
export const circleDetail = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    url: proxyUrl + '/circle/findByCircleId',
    data: qs.stringify(data),

  })
};

//圈子下作品
export const circleWorks = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    url: proxyUrl + '/circle/findTopicByCircleId/page',
    data: qs.stringify(data),

    //data: data
  })
};

//作品评论信息
export const selectReplise = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    url: proxyUrl + '/circle/selectReplyBytopicId',
    data: qs.stringify(data),

    //data: data
  })
};

//提交评论
export const replyTopic = (data) => {
  return request({
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'post',
    url: proxyUrl + '/circle/replyTopic',
    //data: qs.stringify(data)
    data: data,

  })
};

//点赞
export const favorTopic = (data) => {
  return request({
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'post',
    url: proxyUrl + '/circle/favorTopic',
    //data: qs.stringify(data)
    data: data,

  })
};


// 积分
export const integral = (data) => {
  return request({
    // headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'post',
    url: Jingjiribao + '/score/user/score/record',
    data: qs.stringify(data)
    // data: data,

  })
};


// WEBPACK FOOTER //
// ./src/utils/api/circleDetail.js